module.exports = __webpack_public_path__ + "sk-trip-wizard-card-bottom-right.11JXzs1e.png";